import AddIcon from "@mui/icons-material/Add";
import { ColumnDropDividerWrapper } from "designSystem/dnd/index";
import { Box, Button } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewAttributesStore } from "./CustomViewAttributesStore";
import AttributeSelectionGroup from "./AttributesSelectionGroup";

const AttributesSelections: FunctionComponent = observer(function AttributeSelections() {
	const attributesStore = useCustomViewAttributesStore();
	const {
		onAddAdHocGroup,
		options,
		selections,
	} = attributesStore;

	return (
		<>
			<ColumnDropDividerWrapper>
				{selections.map((group) => (
					<AttributeSelectionGroup
						group={group}
						key={group.id}
					/>
				))}
			</ColumnDropDividerWrapper>
			{!options?.noGroupSupport && (
				<Box>
					<Button
						design="outline"
						onClick={onAddAdHocGroup}
						res="CustomViewCreateCustomGroup"
						startIcon={<AddIcon />}
					/>
				</Box>
			)}
		</>
	);
});

export default AttributesSelections;